import React from 'react';

const Circle = () => {
  return (
    <svg height="8" width="8" viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg">
      <circle cx="50" cy="50" r="50" />
    </svg>
  );
};

export default Circle;
